/* eslint-disable import/no-anonymous-default-export */
import { energy_fields } from "../recommendations/components/Bands/EnergyBand";
import { water_fields } from "../recommendations/components/Bands/WaterBand";
import { bandPositions, bands } from "./components/FilterModal/constants";
import { enrichFilterFields } from "./filterFieldBuilders";
import * as actionType from "./constants";
const role = localStorage.getItem("role");
const isConsultancyOrAdmin = role === "consultancy_user" || role === "super_admin";
let initialMaterFilters = [
    {
        label: "Trade",
        key: "trades",
        paramKey: "trade_ids",
        exportFilterKey: "trade_id",
        band: bands.recommendation,
        bandPosition: bandPositions.header,
        isRecommendationField: true,
        getListKey: ["trades.id", "trades.name"],
        searchKey: "recommendations.trade_name"
    },
    {
        label: "System",
        key: "system",
        paramKey: "system_ids",
        exportFilterKey: "system_id",
        band: bands.recommendation,
        bandPosition: bandPositions.header,
        isRecommendationField: true,
        getListKey: ["systems.id", "systems.name"],
        searchKey: "recommendations.system_name"
    },
    {
        label: "Sub System",
        key: "sub_system",
        paramKey: "sub_system_ids",
        exportFilterKey: "sub_system_id",
        band: bands.recommendation,
        bandPosition: bandPositions.header,
        isRecommendationField: true,
        getListKey: ["sub_systems.id", "sub_systems.name"],
        searchKey: "recommendations.sub_system_name"
    },
    {
        label: "Recommendation Type",
        key: "recommendation_type",
        paramKey: "recommendation_type",
        exportFilterKey: "recommendation_type",
        band: bands.recommendation,
        bandPosition: bandPositions.body,
        searchKey: "recommendation_type",
        isRecommendationField: true,
        getListKey: ["recommendations.recommendation_type"]
        // options: [
        //     { id: "asset", name: "Asset" },
        //     { id: "building", name: "Building" }
        // ]
    },
    {
        label: "Recommendation",
        key: "description",
        paramKey: "recommendations.description",
        exportFilterKey: "recommendations.description",
        band: bands.recommendation,
        bandPosition: bandPositions.body,
        isWildCardFilter: true,
        fieldType: "text"
    },
    {
        label: "Recommendation Narrative",
        key: "notes",
        paramKey: "recommendations.notes",
        exportFilterKey: "recommendations.notes",
        band: bands.recommendation,
        bandPosition: bandPositions.body,
        isWildCardFilter: true,
        fieldType: "text"
    },
    {
        label: "Regions",
        key: "regions",
        paramKey: "region_ids",
        exportFilterKey: "region_id",
        band: bands.geo_hierarchy,
        bandPosition: bandPositions.header,
        getListKey: ["regions.id", "regions.name"],
        searchKey: "recommendations.region_name"
    },
    {
        label: "Sites",
        key: "sites",
        paramKey: "site_ids",
        exportFilterKey: "site_id",
        band: bands.geo_hierarchy,
        bandPosition: bandPositions.header,
        getListKey: ["sites.id", "sites.name"],
        searchKey: "recommendations.site_name"
    },
    {
        label: "Buildings",
        key: "buildings",
        paramKey: "building_ids",
        exportFilterKey: "building_id",
        band: bands.geo_hierarchy,
        bandPosition: bandPositions.header,
        getListKey: ["buildings.id", "buildings.name"],
        searchKey: "buildings.name"
    },
    {
        label: "Building Types",
        key: "building_types",
        paramKey: "building_types",
        exportFilterKey: "building_type_id",
        band: bands.geo_hierarchy,
        bandPosition: bandPositions.body,
        getListKey: ["main_building_types.id", "main_building_types.name"],
        searchKey: "main_building_types.name"
    },
    {
        label: "Additions",
        key: "additions",
        paramKey: "addition_ids",
        exportFilterKey: "addition_id",
        band: bands.geo_hierarchy,
        bandPosition: bandPositions.body,
        searchKey: "recommendations.addition_name",
        getListKey: ["additions.id", "additions.name"]
    },
    {
        label: "Floors",
        key: "floors",
        paramKey: "floor_ids",
        exportFilterKey: "floor_id",
        band: bands.geo_hierarchy,
        bandPosition: bandPositions.body,
        isRecommendationField: true,
        searchKey: "recommendations.floor_name",
        getListKey: ["floors.id", "floors.name"]
    },
    {
        label: "Space Types",
        key: "space_types",
        paramKey: "recommendation_space_type_ids",
        exportFilterKey: "recommendation_space_type_ids",
        band: bands.geo_hierarchy,
        bandPosition: bandPositions.body,
        isRecommendationField: true,
        searchKey: "recommendations.recommendation_space_types",
        getListKey: ["recommendation_space_types.id", "recommendation_space_types.name"]
    },
    //csp fields
    {
        label: "Construction Cost",
        key: "project_total",
        paramKey: "recommendations.project_total",
        exportFilterKey: "recommendations.project_total",
        band: bands.capital_spending_plan,
        bandPosition: bandPositions.header,
        searchKey: "recommendations.project_total",
        isRecommendationField: true,
        isWildCardFilter: true,
        fieldType: "number",
        hasTopNFilterField: true
    },
    {
        label: "Project Cost",
        key: "project_costs",
        paramKey: "recommendations.project_costs",
        wildcardParamKey: "recommendations.project_costs",
        exportFilterKey: "recommendations.project_costs",
        band: bands.capital_spending_plan,
        bandPosition: bandPositions.header,
        searchKey: "recommendations.project_costs",
        isRecommendationField: true,
        isWildCardFilter: true,
        fieldType: "number"
    },
    {
        label: "Years",
        key: "year",
        paramKey: "year",
        exportFilterKey: "year",
        band: bands.capital_spending_plan,
        bandPosition: bandPositions.header,
        searchKey: "",
        isRecommendationField: true,
        getListKey: ["maintenance_years.year"]
    },
    {
        label: "Unit",
        key: "unit",
        paramKey: "unit",
        wildcardParamKey: "unit",
        exportFilterKey: "unit",
        band: bands.capital_spending_plan,
        bandPosition: bandPositions.header,
        isRecommendationField: true,
        searchKey: "unit",
        isWildCardFilter: true,
        fieldType: "text"
    },
    {
        label: "Cost Per Unit",
        key: "cost_per_unit",
        paramKey: "cost_per_unit",
        wildcardParamKey: "cost_per_unit",
        exportFilterKey: "cost_per_unit",
        band: bands.capital_spending_plan,
        bandPosition: bandPositions.body,
        searchKey: "cost_per_unit",
        isWildCardFilter: true,
        fieldType: "number"
    },
    {
        label: "Quantity",
        key: "quantity",
        paramKey: "quantity",
        wildcardParamKey: "quantity",
        exportFilterKey: "quantity",
        band: bands.capital_spending_plan,
        bandPosition: bandPositions.body,
        searchKey: "quantity",
        isWildCardFilter: true,
        fieldType: "number"
    },
    {
        label: "Opinions of Cost",
        key: "options_cost",
        paramKey: "options_cost",
        wildcardParamKey: "options_cost",
        exportFilterKey: "options_cost",
        band: bands.capital_spending_plan,
        bandPosition: bandPositions.body,
        searchKey: "options_cost",
        isWildCardFilter: true,
        fieldType: "number"
    },
    //asset fields
    {
        label: "Asset Name",
        key: "asset_name",
        paramKey: "assets.asset_name",
        exportFilterKey: "assets.asset_name",
        band: bands.asset,
        bandPosition: bandPositions.header,
        isWildCardFilter: true,
        fieldType: "text"
    },
    {
        label: "Asset Condition",
        key: "asset_condition",
        paramKey: "asset_condition_ids",
        exportFilterKey: "asset_condition",
        band: bands.asset,
        bandPosition: bandPositions.header,
        isRecommendationField: true,
        searchKey: "condition",
        wildcardParamKey: "asset_condition",
        getListKey: ["asset.condition"]
    },
    {
        label: "Asset Tag",
        key: "asset_tag",
        paramKey: "assets.asset_tag",
        exportFilterKey: "assets.asset_tag",
        band: bands.asset,
        bandPosition: bandPositions.header,
        isWildCardFilter: true,
        fieldType: "text"
    },
    {
        label: "Manufacturer",
        key: "manufacturer",
        paramKey: "asset_manufacturer_id",
        exportFilterKey: "asset_manufacturer_id",
        band: bands.asset,
        bandPosition: bandPositions.body,
        isRecommendationField: true,
        searchKey: "assets.manufacturer",
        getListKey: ["assets.manufacturer"]
    },
    {
        label: "Model Number",
        key: "model_number",
        paramKey: "assets.model_number",
        exportFilterKey: "assets.model_number",
        band: bands.asset,
        bandPosition: bandPositions.body,
        isWildCardFilter: true,
        fieldType: "text"
    },
    {
        label: "Serial Number",
        key: "serial_number",
        paramKey: "assets.serial_number",
        exportFilterKey: "assets.serial_number",
        band: bands.asset,
        bandPosition: bandPositions.body,
        isWildCardFilter: true,
        fieldType: "text"
    },
    {
        label: "Refrigerant",
        key: "refrigerant",
        paramKey: "assets.refrigerant",
        exportFilterKey: "assets.refrigerant",
        band: bands.asset,
        bandPosition: bandPositions.body,
        isWildCardFilter: true,
        fieldType: "text"
    },
    {
        label: "Installed Year",
        key: "asset_installed_year",
        paramKey: "assets.installed_year",
        exportFilterKey: "assets.installed_year",
        band: bands.asset,
        bandPosition: bandPositions.body,
        isWildCardFilter: true,
        fieldType: "year"
    },
    {
        label: "Current Age",
        key: "asset_current_age",
        paramKey: "assets.current_age",
        exportFilterKey: "assets.current_age",
        band: bands.asset,
        bandPosition: bandPositions.body,
        isWildCardFilter: true,
        fieldType: "number"
    },
    {
        label: "Service Life",
        key: "asset_service_life",
        paramKey: "assets.service_life",
        exportFilterKey: "assets.service_life",
        band: bands.asset,
        bandPosition: bandPositions.body,
        isWildCardFilter: true,
        fieldType: "number"
    },
    {
        label: "End of Service Life",
        key: "asset_end_of_service_life",
        paramKey: "assets.end_of_service_life",
        exportFilterKey: "assets.end_of_service_life",
        band: bands.asset,
        bandPosition: bandPositions.body,
        isWildCardFilter: true,
        fieldType: "number"
    },
    {
        label: "Useful Life Remaining",
        key: "asset_useful_life_remaining",
        paramKey: "assets.usefull_life_remaining",
        exportFilterKey: "assets.usefull_life_remaining",
        band: bands.asset,
        bandPosition: bandPositions.body,
        isWildCardFilter: true,
        fieldType: "number"
    },
    {
        label: "Capacity",
        key: "capacity",
        paramKey: "assets.capacity",
        exportFilterKey: "assets.capacity",
        band: bands.asset,
        bandPosition: bandPositions.body,
        isWildCardFilter: true,
        fieldType: "text"
    },
    {
        label: "Capacity Unit",
        key: "capacity_unit",
        paramKey: "assets.capacity_unit",
        exportFilterKey: "assets.capacity_unit",
        band: bands.asset,
        bandPosition: bandPositions.body,
        isWildCardFilter: true,
        fieldType: "text"
    },
    {
        label: "Uniformat Level 1",
        key: "uniformat_level_1",
        paramKey: "uniformat_level_1s_ids",
        exportFilterKey: "uniformat_level_1s_ids",
        band: bands.asset,
        bandPosition: bandPositions.body,
        isRecommendationField: true,
        searchKey: "assets.uniformat_level_1s.name",
        getListKey: ["assets.uniformat_level_1s.id", "assets.uniformat_level_1s.name"]
    },
    {
        label: "Uniformat Level 2",
        key: "uniformat_level_2.name",
        paramKey: "uniformat_level_2s_ids",
        exportFilterKey: "uniformat_level_2s_ids",
        band: bands.asset,
        bandPosition: bandPositions.body,
        isRecommendationField: true,
        searchKey: "assets.uniformat_level_2s.name",
        getListKey: ["assets.uniformat_level_2s.id", "assets.uniformat_level_2s.name"]
    },
    {
        label: "Uniformat Level 3",
        key: "uniformat_level_3.name",
        paramKey: "uniformat_level_3s_ids",
        exportFilterKey: "uniformat_level_3s_ids",
        band: bands.asset,
        bandPosition: bandPositions.body,
        isRecommendationField: true,
        searchKey: "assets.uniformat_level_3s.name",
        getListKey: ["assets.uniformat_level_3s.id", "assets.uniformat_level_3s.name"]
    },
    {
        label: "Uniformat Level 4",
        key: "uniformat_level_4.name",
        paramKey: "uniformat_level_4s_ids",
        exportFilterKey: "uniformat_level_4s_ids",
        band: bands.asset,
        bandPosition: bandPositions.body,
        isRecommendationField: true,
        searchKey: "assets.uniformat_level_4s.name",
        getListKey: ["assets.uniformat_level_4s.id", "assets.uniformat_level_4s.name"]
    },
    {
        label: "Uniformat Level 5",
        key: "uniformat_level_5.name",
        paramKey: "uniformat_level_5s_ids",
        exportFilterKey: "uniformat_level_5s_ids",
        band: bands.asset,
        bandPosition: bandPositions.body,
        isRecommendationField: true,
        searchKey: "assets.uniformat_level_5s.name",
        getListKey: ["assets.uniformat_level_5s.id", "assets.uniformat_level_5s.name"]
    },
    {
        label: "Uniformat Level 6",
        key: "uniformat_level_6.name",
        paramKey: "uniformat_level_6s_ids",
        exportFilterKey: "uniformat_level_6s_ids",
        band: bands.asset,
        bandPosition: bandPositions.body,
        isRecommendationField: true,
        searchKey: "assets.uniformat_level_6s.name",
        getListKey: ["assets.uniformat_level_6s.id", "assets.uniformat_level_6s.name"]
    },
    {
        label: "Condition",
        key: "condition",
        paramKey: "condition_ids",
        exportFilterKey: "condition",
        band: bands.additional_details,
        bandPosition: bandPositions.header,
        isRecommendationField: true,
        searchKey: "condition",
        wildcardParamKey: "system_condition",
        getListKey: ["recommendations.condition"]
    },
    {
        label: "Category",
        key: "category",
        paramKey: "category_ids",
        exportFilterKey: "category_id",
        band: bands.additional_details,
        bandPosition: bandPositions.header,
        searchKey: "recommendations.category_name",
        isRecommendationField: true,
        getListKey: ["categories.id", "categories.name"]
    },
    {
        label: "Capital Type",
        key: "capital_type",
        paramKey: "capital_type_ids",
        exportFilterKey: "capital_type_id",
        band: bands.additional_details,
        bandPosition: bandPositions.body,
        searchKey: "recommendations.capital_type_name",
        isRecommendationField: true,
        getListKey: ["recommendation_capital_types.id", "recommendation_capital_types.display_name"]
    },
    {
        label: "Status",
        key: "status",
        paramKey: "status_ids",
        exportFilterKey: "status",
        band: bands.additional_details,
        bandPosition: bandPositions.header,
        searchKey: "status",
        isRecommendationField: true,
        getListKey: ["recommendations.status"],
        hasGroupBy: true
    },
    {
        label: "CR Status",
        key: "cr_status",
        paramKey: "cr_status_ids",
        exportFilterKey: "cr_status",
        band: bands.additional_details,
        bandPosition: bandPositions.header,
        searchKey: "status",
        isRecommendationField: true,
        getListKey: ["recommendations.cr_status"]
    },
    {
        label: "Status Notes",
        key: "status_notes",
        paramKey: "status_notes",
        wildcardParamKey: "status_notes",
        exportFilterKey: "status_notes",
        band: bands.additional_details,
        bandPosition: bandPositions.body,
        searchKey: "status_notes",
        isRecommendationField: true,
        isWildCardFilter: true,
        fieldType: "text"
    },
    {
        label: "CSP Status",
        key: "csp_status",
        paramKey: "csp_status",
        exportFilterKey: "csp_status",
        band: bands.additional_details,
        bandPosition: bandPositions.header,
        searchKey: "is_cr",
        isRecommendationField: true,
        getListKey: ["recommendations.is_cr"],
        dashboardOnly: true
    },
    {
        label: "Installed Year",
        key: "installed_year",
        paramKey: "recommendations.installed_year",
        exportFilterKey: "recommendations.installed_year",
        band: bands.additional_details,
        bandPosition: bandPositions.body,
        isWildCardFilter: true,
        fieldType: "year"
    },
    {
        label: "Service Life",
        key: "service_life",
        paramKey: "recommendations.service_life",
        exportFilterKey: "recommendations.service_life",
        band: bands.additional_details,
        bandPosition: bandPositions.body,
        isWildCardFilter: true,
        fieldType: "number"
    },
    {
        label: "Useful Life Remaining",
        key: "useful_life_remaining",
        paramKey: "recommendations.usefull_life_remaining",
        exportFilterKey: "recommendations.usefull_life_remaining",
        band: bands.additional_details,
        bandPosition: bandPositions.body,
        isWildCardFilter: true,
        fieldType: "number"
    },
    {
        label: "CRV",
        key: "crv",
        paramKey: "recommendations.crv",
        exportFilterKey: "recommendations.crv",
        band: bands.additional_details,
        bandPosition: bandPositions.body,
        isWildCardFilter: true,
        fieldType: "number"
    },

    {
        label: "Initiative",
        key: "initiative",
        paramKey: "initiative_ids",
        exportFilterKey: "initiative_id",
        band: bands.additional_details,
        bandPosition: bandPositions.body,
        searchKey: "recommendations.initiative_name",
        isRecommendationField: true,
        getListKey: ["initiatives.id", "initiatives.name"]
    },
    {
        label: "Funding",
        key: "funding_source",
        paramKey: "funding_source_ids",
        exportFilterKey: "funding_source_id",
        band: bands.additional_details,
        bandPosition: bandPositions.body,
        searchKey: "recommendations.funding_source_name",
        isRecommendationField: true,
        getListKey: ["funding_sources.id", "funding_sources.name"]
    },
    {
        label: "Responsibility",
        key: "responsibility",
        paramKey: "responsibility_ids",
        exportFilterKey: "responsibility_id",
        band: bands.additional_details,
        bandPosition: bandPositions.body,
        searchKey: "recommendations.responsibility_name",
        isRecommendationField: true,
        getListKey: ["recommendations.responsibility_id", "recommendations.responsibility_name"]
    },
    {
        label: "Origin",
        key: "source",
        paramKey: "source_ids",
        exportFilterKey: "source",
        band: bands.additional_details,
        bandPosition: bandPositions.body,
        searchKey: "source",
        isRecommendationField: true,
        getListKey: ["recommendations.source"]
    },
    {
        label: "Birth Year",
        key: "birth_year",
        paramKey: "recommendations.birth_year",
        exportFilterKey: "recommendations.birth_year",
        band: bands.additional_details,
        bandPosition: bandPositions.body,
        isWildCardFilter: true,
        fieldType: "number"
    },
    {
        label: "Surveyor",
        key: "surveyor",
        paramKey: "surveyor_ids",
        exportFilterKey: "surveyor",
        band: bands.additional_details,
        bandPosition: bandPositions.body,
        searchKey: "recommendations.surveyor",
        isRecommendationField: true,
        getListKey: ["recommendations.surveyor"]
    },
    {
        label: "Inspection Date",
        key: "inspection_date",
        paramKey: "recommendations.inspection_date",
        wildcardParamKey: "recommendations.inspection_date",
        exportFilterKey: "recommendations.inspection_date",
        band: bands.additional_details,
        bandPosition: bandPositions.body,
        searchKey: "recommendations.inspection_date",
        isRecommendationField: true,
        isWildCardFilter: true,
        fieldType: "date"
    },
    {
        label: "Requester",
        key: "requestor",
        paramKey: "requestor_ids",
        exportFilterKey: "requestor",
        band: bands.additional_details,
        bandPosition: bandPositions.body,
        searchKey: "recommendations.requestor_name",
        isRecommendationField: true,
        getListKey: ["recommendations.requestor_id", "recommendations.requestor_name"]
    },
    {
        label: "Capital Request",
        key: "infrastructure_requests",
        paramKey: "infrastructure_requests",
        exportFilterKey: "infrastructure_request",
        band: bands.additional_details,
        bandPosition: bandPositions.body,
        searchKey: "infrastructure_request",
        isRecommendationField: true,
        getListKey: ["recommendations.infrastructure_request"]
    },
    {
        label: "Has CR",
        key: "has_cr",
        paramKey: "has_cr",
        exportFilterKey: "has_cr",
        band: bands.additional_details,
        bandPosition: bandPositions.body,
        searchKey: "has_cr",
        isRecommendationField: true,
        getListKey: ["has_cr"],
        useRecommendationGetList: true,
        cspSource: "recommendation"
    },
    {
        label: "Has Recommendations",
        key: "has_recommendations",
        paramKey: "has_recommendations",
        exportFilterKey: "has_recommendations",
        band: bands.additional_details,
        bandPosition: bandPositions.body,
        searchKey: "has_recommendations",
        isRecommendationField: true,
        getListKey: ["has_recommendations"],
        useRecommendationGetList: true,
        cspSource: "capital_request"
    },
    {
        label: "Redlining",
        key: "redlining",
        paramKey: "redlining",
        exportFilterKey: "redlining",
        band: bands.additional_details,
        bandPosition: bandPositions.body,
        searchKey: "red_line",
        isRecommendationField: true,
        getListKey: ["recommendations.red_line"]
    },
    {
        label: "Continuous FCA",
        key: "continuousFca",
        paramKey: "continuous_fca",
        exportFilterKey: "continuous_fca",
        band: bands.additional_details,
        bandPosition: bandPositions.body,
        searchKey: "continuous_fca",
        isRecommendationField: true,
        getListKey: ["recommendations.continuous_fca"]
    },
    {
        label: "Budget Priority",
        key: "budget_priority",
        paramKey: "budget_priority",
        exportFilterKey: "budget_priority",
        band: bands.additional_details,
        bandPosition: bandPositions.body,
        searchKey: "budget_priority",
        isRecommendationField: true,
        getListKey: ["recommendations.budget_priority"]
    },
    {
        label: "Year(s)",
        key: "years_with_value",
        paramKey: "recommendations.years_with_value",
        wildcardParamKey: "recommendations.years_with_value",
        exportFilterKey: "recommendations.years_with_value",
        band: bands.additional_details,
        bandPosition: bandPositions.body,
        searchKey: "recommendations.years_with_value",
        isRecommendationField: true,
        isWildCardFilter: true,
        fieldType: "text"
    },
    {
        label: "Created At",
        key: "created_at",
        paramKey: "recommendations.created_at",
        wildcardParamKey: "recommendations.created_at",
        exportFilterKey: "recommendations.created_at",
        band: bands.additional_details,
        bandPosition: bandPositions.body,
        searchKey: "recommendations.created_at",
        isRecommendationField: true,
        isWildCardFilter: true,
        fieldType: "date"
    },
    {
        label: "Updated At",
        key: "updated_at",
        paramKey: "recommendations.updated_at",
        wildcardParamKey: "recommendations.updated_at",
        exportFilterKey: "recommendations.updated_at",
        band: bands.additional_details,
        bandPosition: bandPositions.body,
        searchKey: "recommendations.updated_at",
        isRecommendationField: true,
        isWildCardFilter: true,
        fieldType: "date"
    },
    {
        label: "Surveyor Role",
        key: "surveyor_roles",
        paramKey: "surveyor_roles",
        exportFilterKey: "surveyor_roles",
        band: bands.other,
        bandPosition: bandPositions.header,
        searchKey: "recommendations.surveyor_role",
        isRecommendationField: true,
        getListKey: ["recommendations.surveyor_role"]
    },
    {
        label: "Clients",
        key: "clients",
        paramKey: "client_ids",
        hide: role === "client_user",
        exportFilterKey: "client_id",
        band: bands.other,
        bandPosition: bandPositions.header,
        searchKey: "recommendations.client_name",
        getListKey: ["clients.id", "clients.name"]
    },
    {
        label: "FCA Projects",
        key: "projects",
        paramKey: "project_ids",
        exportFilterKey: "project_id",
        band: bands.other,
        bandPosition: bandPositions.header,
        searchKey: "recommendations.project_name",
        getListKey: ["projects.id", "projects.name"]
    },
    {
        label: "QA/QC Issue",
        key: "review_titles",
        paramKey: "review_titles",
        exportFilterKey: "review_titles",
        hide: !isConsultancyOrAdmin,
        band: bands.qa_qc,
        bandPosition: bandPositions.header,
        getListKey: ["recommendation_reviews.title"],
        useRecommendationGetList: true
    },
    {
        label: "Reviewer",
        key: "reviewers",
        paramKey: "reviewer_ids",
        exportFilterKey: "reviewer_id",
        hide: !isConsultancyOrAdmin,
        band: bands.qa_qc,
        bandPosition: bandPositions.header,
        getListKey: ["recommendation_reviews.reviewer_id", "reviewers.name"],
        useRecommendationGetList: true
    },
    {
        label: "Issue Status",
        key: "review_status_ids",
        paramKey: "review_status_ids",
        exportFilterKey: "review_status_ids",
        hide: !isConsultancyOrAdmin,
        band: bands.qa_qc,
        bandPosition: bandPositions.header,
        getListKey: ["recommendation_reviews.status"],
        useRecommendationGetList: true
    },
    {
        label: "QA Status",
        key: "qa_qc_status",
        paramKey: "qa_qc_status_ids",
        exportFilterKey: "qa_qc_status",
        hide: !isConsultancyOrAdmin,
        band: bands.qa_qc,
        bandPosition: bandPositions.body,
        getListKey: ["recommendations.qa_qc_status"],
        useRecommendationGetList: true
    },
    {
        label: "Resolved Date",
        key: "review_resolved_at",
        paramKey: "recommendation_reviews.resolved_at",
        wildcardParamKey: "recommendation_reviews.resolved_at",
        exportFilterKey: "recommendation_reviews.resolved_at",
        hide: !isConsultancyOrAdmin,
        band: bands.qa_qc,
        bandPosition: bandPositions.body,
        isWildCardFilter: true,
        fieldType: "date"
    },
    {
        label: "Added Date",
        key: "review_created_at",
        paramKey: "recommendation_reviews.created_at",
        wildcardParamKey: "recommendation_reviews.created_at",
        exportFilterKey: "recommendation_reviews.created_at",
        hide: !isConsultancyOrAdmin,
        band: bands.qa_qc,
        bandPosition: bandPositions.body,
        isWildCardFilter: true,
        fieldType: "date"
    },
    {
        label: "Comments",
        key: "review_comments",
        paramKey: "recommendation_review_comments.comment",
        wildcardParamKey: "recommendation_review_comments.comment",
        exportFilterKey: "recommendation_review_comments.comment",
        hide: !isConsultancyOrAdmin,
        band: bands.qa_qc,
        bandPosition: bandPositions.body,
        isWildCardFilter: true,
        fieldType: "text"
    },
    {
        label: "Buildings",
        key: "buildings",
        paramKey: "building_ids",
        exportFilterKey: "building_id",
        band: bands.building,
        bandPosition: bandPositions.header,
        getListKey: ["buildings.id", "buildings.name"],
        searchKey: "buildings.name"
    },
    {
        label: "Area (Sq Ft)",
        key: "building_area",
        paramKey: "buildings.area",
        exportFilterKey: "buildings.area",
        band: bands.building,
        bandPosition: bandPositions.body,
        isWildCardFilter: true,
        fieldType: "number"
    },
    {
        label: "Cost",
        key: "building_cost",
        paramKey: "buildings.cost",
        exportFilterKey: "buildings.cost",
        band: bands.building,
        bandPosition: bandPositions.body,
        isWildCardFilter: true,
        fieldType: "number"
    },
    {
        label: "CRV",
        key: "building_crv",
        paramKey: "buildings.crv",
        exportFilterKey: "buildings.crv",
        band: bands.building,
        bandPosition: bandPositions.body,
        isWildCardFilter: true,
        fieldType: "number"
    },
    {
        label: "FCI",
        key: "building_metrics_fci",
        paramKey: "building_metrics.fci",
        exportFilterKey: "building_metrics.fci",
        band: bands.building,
        bandPosition: bandPositions.body,
        isWildCardFilter: true,
        fieldType: "number"
    },
    {
        label: "FCI Description",
        key: "building_fci",
        paramKey: "building_fci",
        exportFilterKey: "building_fci",
        band: bands.building,
        bandPosition: bandPositions.body,
        isRecommendationField: true,
        searchKey: "building_fci",
        getListKey: ["building_fci"]
    },
    {
        label: "EFCI",
        key: "building_metrics_efci",
        paramKey: "building_metrics.efci",
        exportFilterKey: "building_metrics.efci",
        band: bands.building,
        bandPosition: bandPositions.body,
        isWildCardFilter: true,
        fieldType: "number"
    },
    {
        label: "EFCI Description",
        key: "building_efci",
        paramKey: "building_efci",
        exportFilterKey: "building_efci",
        band: bands.building,
        bandPosition: bandPositions.body,
        isRecommendationField: true,
        searchKey: "building_efci",
        getListKey: ["building_efci"]
    },
    {
        label: "DM",
        key: "building_dm",
        paramKey: "building_metrics.dm",
        exportFilterKey: "building_metrics.dm",
        band: bands.building,
        bandPosition: bandPositions.body,
        isWildCardFilter: true,
        fieldType: "number"
    },
    {
        label: "FC",
        key: "building_fc",
        paramKey: "building_metrics.fc",
        exportFilterKey: "building_metrics.fc",
        band: bands.building,
        bandPosition: bandPositions.body,
        isWildCardFilter: true,
        fieldType: "number"
    },
    {
        label: "CSP",
        key: "building_csp",
        paramKey: "building_metrics.csp",
        exportFilterKey: "building_metrics.csp",
        band: bands.building,
        bandPosition: bandPositions.body,
        isWildCardFilter: true,
        fieldType: "number"
    },
    {
        label: "Ownership Type",
        key: "ownership_type",
        paramKey: "ownership_type",
        exportFilterKey: "ownership_type",
        band: bands.building,
        isRecommendationField: true,
        bandPosition: bandPositions.header,
        getListKey: ["buildings.ownership_type"],
        searchKey: "buildings.ownership_type"
    },
    {
        label: "Primary Uses",
        key: "primary_use",
        paramKey: "primary_use_ids",
        exportFilterKey: "primary_use_ids",
        band: bands.building,
        bandPosition: bandPositions.header,
        getListKey: ["buildings.primary_use"]
    },
    {
        label: "Secondary Uses",
        key: "secondary_use",
        paramKey: "secondary_use_ids",
        exportFilterKey: "secondary_use_ids",
        band: bands.building,
        bandPosition: bandPositions.header,
        getListKey: ["buildings.secondary_use"]
    },
    {
        label: "Sectors",
        key: "sectors",
        paramKey: "sector_ids",
        exportFilterKey: "sector_ids",
        band: bands.building,
        bandPosition: bandPositions.body,
        getListKey: ["buildings.sectors"]
    },
    {
        label: "Internal Groups",
        key: "internal_groups",
        paramKey: "internal_group_ids",
        exportFilterKey: "internal_group_ids",
        band: bands.building,
        bandPosition: bandPositions.body,
        getListKey: ["buildings.internal_groups"]
    },
    {
        label: "Divisions",
        key: "divisions",
        paramKey: "division_ids",
        exportFilterKey: "division_ids",
        band: bands.building,
        bandPosition: bandPositions.body,
        getListKey: ["buildings.divisions"]
    },
    {
        label: "Manager",
        key: "building_manager",
        paramKey: "manager_ids",
        exportFilterKey: "manager_ids",
        band: bands.building,
        bandPosition: bandPositions.body,
        isRecommendationField: true,
        searchKey: "building_manager",
        getListKey: ["buildings.manager"]
    },
    {
        label: "Senior Property Manager",
        key: "building_senior_property_manager",
        paramKey: "senior_property_manager_ids",
        exportFilterKey: "senior_property_manager_ids",
        band: bands.building,
        bandPosition: bandPositions.body,
        isRecommendationField: true,
        searchKey: "building_senior_property_manager",
        getListKey: ["buildings.senior_property_manager"]
    },
    {
        label: "Status",
        key: "building_status",
        paramKey: "building_status_ids",
        exportFilterKey: "building_status_ids",
        band: bands.building,
        bandPosition: bandPositions.body,
        isRecommendationField: true,
        searchKey: "building_status",
        getListKey: ["buildings.status"]
    },
    {
        label: "Criticality",
        key: "building_criticality",
        paramKey: "building_criticality_ids",
        exportFilterKey: "building_criticality_ids",
        band: bands.building,
        bandPosition: bandPositions.body,
        isRecommendationField: true,
        searchKey: "building_criticality",
        getListKey: ["buildings.criticality"]
    },
    {
        label: "Building Number",
        key: "building_number",
        paramKey: "buildings.number",
        exportFilterKey: "buildings.number",
        band: bands.building,
        bandPosition: bandPositions.body,
        isWildCardFilter: true,
        fieldType: "text"
    },
    {
        label: "Country",
        key: "building_country",
        paramKey: "building_country_ids",
        exportFilterKey: "building_country_ids",
        band: bands.building,
        bandPosition: bandPositions.body,
        isRecommendationField: true,
        searchKey: "building_country",
        getListKey: ["buildings.country"]
    },
    {
        label: "State",
        key: "building_state",
        paramKey: "building_state_ids",
        exportFilterKey: "building_state_ids",
        band: bands.building,
        bandPosition: bandPositions.body,
        isRecommendationField: true,
        searchKey: "building_state",
        getListKey: ["buildings.state"]
    },
    {
        label: "Redline Completed",
        key: "building_redline_completed",
        paramKey: "building_redline_completed",
        exportFilterKey: "building_redline_completed",
        band: bands.building,
        bandPosition: bandPositions.body,
        isRecommendationField: true,
        searchKey: "building_redline_completed",
        getListKey: ["buildings.redline_completed"]
    },

    {
        label: "Redline Completed Date",
        key: "building_redline_completed_date",
        paramKey: "buildings.redline_completed_date",
        exportFilterKey: "building_redline_completed_date",
        band: bands.building,
        bandPosition: bandPositions.body,
        isRecommendationField: true,
        searchKey: "building_redline_completed_date",
        getListKey: ["buildings.redline_completed_date"],
        fieldType: "date",
        isWildCardFilter: true
    },
    {
        label: "Continuous FCA Completed",
        key: "building_continuous_fca_completed",
        paramKey: "building_continuous_fca_completed",
        exportFilterKey: "building_continuous_fca_completed",
        band: bands.building,
        bandPosition: bandPositions.body,
        isRecommendationField: true,
        searchKey: "building_continuous_fca_completed",
        getListKey: ["buildings.continuous_fca_completed"]
    },
    {
        label: "Continuous FCA Completed Date",
        key: "building_continuous_fca_completed_date",
        paramKey: "buildings.continuous_fca_completed_date",
        exportFilterKey: "building_continuous_fca_completed_date",
        band: bands.building,
        bandPosition: bandPositions.body,
        isRecommendationField: true,
        searchKey: "building_continuous_fca_completed_date",
        getListKey: ["buildings.continuous_fca_completed_date"],
        fieldType: "date",
        isWildCardFilter: true
    },
    {
        label: "Sites",
        key: "sites",
        paramKey: "site_ids",
        exportFilterKey: "site_id",
        band: bands.site,
        bandPosition: bandPositions.header,
        getListKey: ["sites.id", "sites.name"],
        searchKey: "recommendations.site_name"
    },
    {
        label: "Area (Sq Ft)",
        key: "site_area",
        paramKey: "sites.total_area",
        exportFilterKey: "sites.total_area",
        band: bands.site,
        bandPosition: bandPositions.body,
        isWildCardFilter: true,
        fieldType: "number"
    },
    {
        label: "CRV",
        key: "site_crv",
        paramKey: "site_metrics.crv",
        exportFilterKey: "site_metrics.crv",
        band: bands.site,
        bandPosition: bandPositions.body,
        isWildCardFilter: true,
        fieldType: "number"
    },
    {
        label: "FCI",
        key: "site_metrics_fci",
        paramKey: "site_metrics.fci",
        exportFilterKey: "site_metrics.fci",
        band: bands.site,
        bandPosition: bandPositions.body,
        isWildCardFilter: true,
        fieldType: "number"
    },
    {
        label: "FCI Description",
        key: "site_fci",
        paramKey: "site_fci",
        exportFilterKey: "site_fci",
        band: bands.site,
        bandPosition: bandPositions.body,
        isRecommendationField: true,
        searchKey: "site_fci",
        getListKey: ["site_fci"]
    },
    {
        label: "EFCI",
        key: "site_metrics_efci",
        paramKey: "site_metrics.efci",
        exportFilterKey: "site_metrics.efci",
        band: bands.site,
        bandPosition: bandPositions.body,
        isWildCardFilter: true,
        fieldType: "number"
    },
    {
        label: "EFCI Description",
        key: "site_efci",
        paramKey: "site_efci",
        exportFilterKey: "site_efci",
        band: bands.site,
        bandPosition: bandPositions.body,
        isRecommendationField: true,
        searchKey: "site_efci",
        getListKey: ["site_efci"]
    },
    {
        label: "DM",
        key: "site_dm",
        paramKey: "site_metrics.dm",
        exportFilterKey: "site_metrics.dm",
        band: bands.site,
        bandPosition: bandPositions.body,
        isWildCardFilter: true,
        fieldType: "number"
    },
    {
        label: "FC",
        key: "site_fc",
        paramKey: "site_metrics.fc",
        exportFilterKey: "site_metrics.fc",
        band: bands.site,
        bandPosition: bandPositions.body,
        isWildCardFilter: true,
        fieldType: "number"
    },
    {
        label: "CSP",
        key: "site_csp",
        paramKey: "site_metrics.csp",
        exportFilterKey: "site_metrics.csp",
        band: bands.site,
        bandPosition: bandPositions.body,
        isWildCardFilter: true,
        fieldType: "number"
    },
    {
        label: "Site Status",
        key: "site_status",
        paramKey: "site_status_ids",
        exportFilterKey: "site_status_ids",
        band: bands.site,
        bandPosition: bandPositions.header,
        isRecommendationField: true,
        searchKey: "site_status",
        getListKey: ["sites.status"]
    },
    {
        label: "Country",
        key: "site_country",
        paramKey: "site_country_ids",
        exportFilterKey: "site_country_ids",
        band: bands.site,
        bandPosition: bandPositions.header,
        isRecommendationField: true,
        searchKey: "site_country",
        getListKey: ["sites.country"]
    },
    {
        label: "State",
        key: "site_state",
        paramKey: "site_state_ids",
        exportFilterKey: "site_state_ids",
        band: bands.site,
        bandPosition: bandPositions.body,
        isRecommendationField: true,
        searchKey: "site_state",
        getListKey: ["sites.state"]
    },
    {
        label: "MFP",
        key: "facility_master_plan",
        paramKey: "facility_master_plan",
        exportFilterKey: "fmp",
        band: bands.master_facility_plan,
        bandPosition: bandPositions.header,
        searchKey: "fmp",
        isRecommendationField: true,
        getListKey: ["recommendations.fmp"],
        requiresFmpUser: true
    },
    {
        label: "MFP ID",
        key: "fmp_id",
        paramKey: "recommendations.fmp_id",
        wildcardParamKey: "recommendations.fmp_id",
        exportFilterKey: "recommendations.fmp_id",
        band: bands.master_facility_plan,
        bandPosition: bandPositions.header,
        searchKey: "recommendations.fmp_id",
        isRecommendationField: true,
        isWildCardFilter: true,
        fieldType: "text",
        requiresFmpUser: true
    },
    {
        label: "MFP Project",
        key: "fmp_project",
        paramKey: "recommendations.fmp_project",
        wildcardParamKey: "recommendations.fmp_project",
        exportFilterKey: "recommendations.fmp_project",
        band: bands.master_facility_plan,
        bandPosition: bandPositions.body,
        searchKey: "recommendations.fmp_project",
        isRecommendationField: true,
        isWildCardFilter: true,
        fieldType: "text",
        requiresFmpUser: true
    },
    {
        label: "MFP Track",
        key: "fmp_track",
        paramKey: "recommendations.fmp_track",
        wildcardParamKey: "recommendations.fmp_track",
        exportFilterKey: "recommendations.fmp_track",
        band: bands.master_facility_plan,
        bandPosition: bandPositions.body,
        searchKey: "recommendations.fmp_track",
        isRecommendationField: true,
        isWildCardFilter: true,
        fieldType: "text",
        requiresFmpUser: true
    },
    {
        label: "Energy",
        key: "energy_band_show",
        paramKey: "energy",
        exportFilterKey: "energy",
        band: bands.energy,
        bandPosition: bandPositions.header,
        searchKey: "energy_band_show",
        isRecommendationField: true,
        getListKey: ["recommendations.energy_band_show"],
        requiresShowEnergyBand: true
    },
    {
        label: "Water",
        key: "water_band_show",
        paramKey: "water",
        exportFilterKey: "water",
        band: bands.water,
        bandPosition: bandPositions.header,
        searchKey: "water_band_show",
        isRecommendationField: true,
        getListKey: ["recommendations.water_band_show"],
        requiresShowWaterBand: true
    }
];
const energyFields = energy_fields.map((item, i) => ({
    label: item.label,
    key: `energy_band_${item.key}`,
    paramKey: `energy_bands.${item.key}`,
    wildcardParamKey: `energy_bands.${item.key}`,
    exportFilterKey: `energy_bands.${item.key}`,
    band: bands.energy,
    bandPosition: [0, 1].includes(i) ? bandPositions.header : bandPositions.body,
    searchKey: `energy_bands.${item.key}`,
    isWildCardFilter: true,
    fieldType: item.type,
    isRecommendationField: true,
    requiresShowEnergyBand: true
}));
const waterFields = water_fields.map((item, i) => ({
    label: item.tableLabel || item.label,
    key: `water_band_${item.key}`,
    paramKey: `water_bands.${item.key}`,
    wildcardParamKey: `water_bands.${item.key}`,
    exportFilterKey: `water_bands.${item.key}`,
    band: bands.water,
    bandPosition: [0, 1].includes(i) ? bandPositions.header : bandPositions.body,
    searchKey: `water_bands.${item.key}`,
    isWildCardFilter: true,
    fieldType: item.type,
    isRecommendationField: true,
    requiresShowWaterBand: true
}));

initialMaterFilters = [...initialMaterFilters, ...energyFields, ...waterFields];
const initialState = {
    getDashboard: {},
    getDashboardChart: {},
    getDashboardParallelChart: {},
    getFciChart: {},
    getHorizontalChart: {},
    getMap: {},
    getAllLegents: {},
    getFilterColors: {},
    filterValues: {},
    dashboardExtraFilters: [],
    backUpNames: {},
    backUpValues: {},
    popUpData: {},
    filterContents: [],
    landingPageData: {},
    widgetData: {},
    landingPageReport: {},
    isFullScreen: undefined,
    secondChartView: "",
    accordianOpen: null,
    activeLandingPageMenu: "",
    masterFilterList: {},
    masterFilterCount: {},
    defaultProject: localStorage.getItem("default_project"),
    dashboardResetFlag: false,
    dropdownLoader: {},
    filterFields: enrichFilterFields(initialMaterFilters),
    tempChartFilters: {},
    tempQueryChartFilters: {},
    saveFilterQuery: {},
    getQueryData: { isQueryLoading: false },
    queryEntityParams: {
        paginationParams: {
            totalPages: 0,
            perPage: 100,
            currentPage: 0,
            totalCount: 0
        },
        params: {
            limit: 100,
            offset: 0,
            search: "",
            filters: null,
            list: null,
            order: null
        }
    },
    deleteQueryResponse: {},
    saveQueryResponse: { success: false },
    updateQueryResponse: { success: false },
    updateFilterName: {},
    getUserByClientQueryData: {},
    getQueryFilterCreatedUsersData: {},
    addFavouriteQueryData: {},
    assignFavouriteQueryData: {},
    getQuickLinksResponse: null,
    addToQuickLinks: null,
    individualFilters: {},
    hasAppliedInitialFilters: false,
    getDashboardLeaseAssetsCountResponse: null,
    chartDynamicFields: null,
    getDashboardLoading: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_DASHBOARD_REQUEST:
            return {
                ...state
            };
        case actionType.GET_DASHBOARD_SUCCESS:
            const previousYears = state.getDashboard?.years || {};
            const newYears = action.response?.years || {};
            const { chart, fci_charts, horizontal_chart, map, ...rest } = action.response || {};
            return {
                ...state,
                getDashboard: {
                    success: true,
                    ...rest,
                    years: {
                        start: newYears.start != null ? newYears.start : previousYears.start,
                        end: newYears.end != null ? newYears.end : previousYears.end
                    }
                },
                getDashboardLoading: false
            };
        case actionType.GET_DASHBOARD_FAILURE:
            return {
                ...state,
                getDashboard: { success: false, ...action.error },
                getDashboardLoading: false
            };
        case actionType.CLEAR_DASHBOARD_DATA:
            return {
                ...state,
                getDashboard: {},
                individualFilters: {},
                isFullScreen: undefined,
                updateFilterName: {}
            };
        case actionType.GET_DASHBOARD_CHART_REQUEST:
            return {
                ...state,
                getDashboardChart: { isLoading: true }
            };
        case actionType.GET_DASHBOARD_CHART_SUCCESS:
            return {
                ...state,
                getDashboardChart: { ...state.getDashboardChart, ...action.response, isLoading: false }
            };
        case actionType.GET_DASHBOARD_CHART_FAILURE:
            return {
                ...state,
                getDashboardChart: { chart: [], success: false, isLoading: false }
            };
        case actionType.GET_DASHBOARD_CHART_PARALLEL_REQUEST:
            return {
                ...state,
                getDashboardParallelChart: { isLoading: true }
            };
        case actionType.GET_DASHBOARD_CHART_PARALLEL_SUCCESS:
            return {
                ...state,
                getDashboardParallelChart: { ...state.getDashboardParallelChart, ...action.response, isLoading: false }
            };
        case actionType.GET_DASHBOARD_CHART_PARALLEL_FAILURE:
            return {
                ...state,
                getDashboardParallelChart: { chart: [], success: false, isLoading: false }
            };
        case actionType.GET_DASHBOARD_FCI_CHART_REQUEST:
            return {
                ...state,
                getFciChart: { isLoading: true }
            };
        case actionType.GET_DASHBOARD_FCI_CHART_SUCCESS:
            return {
                ...state,
                getFciChart: { success: true, ...action.response, isLoading: false }
            };
        case actionType.GET_DASHBOARD_FCI_CHART_FAILURE:
            return {
                ...state,
                getFciChart: { success: false, ...action.error, isLoading: false }
            };
        case actionType.GET_DASHBOARD_MAP_CHART_REQUEST:
            return {
                ...state,
                getMap: { isLoading: true }
            };
        case actionType.GET_DASHBOARD_MAP_CHART_SUCCESS:
            return {
                ...state,
                getMap: { success: true, ...action.response, isLoading: false }
            };
        case actionType.GET_DASHBOARD_MAP_CHART_FAILURE:
            return {
                ...state,
                getMap: { success: false, ...action.error, isLoading: false }
            };
        case actionType.GET_DASHBOARD_HORIZONTAL_CHART_REQUEST:
            return {
                ...state,
                getHorizontalChart: { isLoading: true }
            };
        case actionType.GET_DASHBOARD_HORIZONTAL_CHART_SUCCESS:
            return {
                ...state,
                getHorizontalChart: { success: true, ...action.response, isLoading: false }
            };
        case actionType.GET_DASHBOARD_HORIZONTAL_CHART_FAILURE:
            return {
                ...state,
                getHorizontalChart: { success: false, ...action.error, isLoading: false }
            };
        //filter values
        case actionType.GET_FILTER_PROJECT_REQUEST:
            return {
                ...state,
                dropdownLoader: { ...state.dropdownLoader, [action.key]: true }
            };
        case actionType.GET_FILTER_PROJECT_SUCCESS:
            return {
                ...state,
                masterFilterList: {
                    ...state.masterFilterList,
                    [action.key]: action.isRecommendationField ? [...action.response?.list] : [...action.response?.[action.key]]
                },
                masterFilterCount: action.isServerSearch
                    ? state.masterFilterCount
                    : { ...state.masterFilterCount, [action.key]: action.response?.count ?? null },
                dropdownLoader: { ...state.dropdownLoader, [action.key]: false }
            };
        case actionType.GET_FILTER_PROJECT_FAILURE:
            return {
                ...state,
                masterFilterList: {},
                dropdownLoader: { ...state.dropdownLoader, [action.key]: false }
            };

        case actionType.GET_LEGENTS_REQUEST:
            return {
                ...state
            };
        case actionType.GET_LEGENTS_SUCCESS:
            return {
                ...state,
                getAllLegents: { success: true, ...action.response }
            };
        case actionType.GET_LEGENTS_FAILURE:
            return {
                ...state,
                getAllLegents: { success: false, ...action.error }
            };

        case actionType.MODIFY_FILTER_REQUEST:
            return {
                ...state,
                filterContents: action.response.param || [],
                filterValues: { ...action.response.values },
                dashboardExtraFilters: action.response.dashboardExtraFilters || [],
                backUpNames: action.response.backUpNames,
                backUpValues: action.response.backUpValues
            };
        case actionType.SAVE_INDIVIDUAL_CHART_PARAMS:
            return {
                ...state,
                individualFilters: { ...action.response }
            };
        case actionType.SAVE_TEMP_CHART_FILTERS:
            return {
                ...state,
                tempChartFilters: { ...action.response }
            };
        case actionType.SAVE_QUERY_TEMP_CHART_FILTERS: {
            return {
                ...state,
                tempQueryChartFilters: { ...action.response }
            };
        }
        case actionType.MODIFY_POP_UP_REQUEST:
            return {
                ...state,
                popUpData: action.response.data
            };

        case actionType.GET_LANDING_PAGE_REQUEST:
            return {
                ...state
            };
        case actionType.GET_LANDING_PAGE_SUCCESS:
            return {
                ...state,
                landingPageData: { success: true, ...action.response }
            };
        case actionType.GET_LANDING_PAGE_FAILURE:
            return {
                ...state,
                landingPageData: { success: false, ...action.error }
            };
        case actionType.GET_LANDING_PAGE_REPORT_REQUEST:
            return {
                ...state
            };
        case actionType.GET_LANDING_PAGE_REPORT_SUCCESS:
            return {
                ...state,
                landingPageReport: { success: true, ...action.response }
            };
        case actionType.GET_LANDING_PAGE_REPORT_FAILURE:
            return {
                ...state,
                landingPageReport: { success: false, ...action.error }
            };
        case actionType.GET_WIDGET_DATA_REQUEST:
            return {
                ...state
            };
        case actionType.GET_WIDGET_DATA_SUCCESS:
            return {
                ...state,
                widgetData: { success: true, ...action.response }
            };
        case actionType.GET_WIDGET_DATA_FAILURE:
            return {
                ...state,
                widgetData: { success: false, ...action.error }
            };
        case actionType.UPDATE_FULL_SCREEN_SUCCESS:
            return {
                ...state,
                isFullScreen: action.response
            };
        case actionType.UPDATE_FULL_SCREEN_FAILURE:
            return {
                ...state,
                isFullScreen: false
            };
        case actionType.UPDATE_IS_BUDGET_PRIORITY_VIEW_SUCCESS:
            return {
                ...state,
                secondChartView: action.response
            };
        case actionType.UPDATE_IS_BUDGET_PRIORITY_VIEW_FAILURE:
            return {
                ...state,
                secondChartView: ""
            };
        case actionType.UPDATE_TRACKER_MENU_SUCCESS:
            return {
                ...state,
                accordianOpen: action.response
            };
        case actionType.SET_ACTIVE_MENU_SUCCESS:
            return {
                ...state,
                activeLandingPageMenu: action.response
            };
        case actionType.UPDATE_DEFAULT_PROJECT:
            return {
                ...state,
                defaultProject: action.response,
                getDashboardLoading: action.payload?.fromSideMenu ? true : false
            };
        case actionType.TOGGLE_DASHBOARD_RESET_FLAG:
            return {
                ...state,
                dashboardResetFlag: !state.dashboardResetFlag
            };
        case actionType.UPDATE_MASTER_FILTER:
            return {
                ...state,
                filterFields: enrichFilterFields([...initialMaterFilters, ...action.response])
            };
        // Otto (AI filter assistant): seed the applied-filter DISPLAY sources from what the assistant just
        // applied, so the tag-area and the FilterModal "all filters" view render Otto's filters WITHOUT the
        // user first opening each field's dropdown (the only thing that lazily loads masterFilterList).
        // Purely additive + self-healing: fields already present are skipped (deduped by key), and both
        // lists get overwritten by their real loads when the modal opens (UPDATE_MASTER_FILTER / GET_FILTER_PROJECT).
        case actionType.SEED_AI_FILTER_LABELS: {
            const { fields = [], options = {} } = action.response || {};
            const existingFieldKeys = new Set((state.filterFields || []).map(f => f.key));
            const newFields = [];
            fields.forEach(f => {
                if (f && f.key && !existingFieldKeys.has(f.key)) {
                    existingFieldKeys.add(f.key);
                    newFields.push(f);
                }
            });
            const masterFilterList = { ...state.masterFilterList };
            Object.entries(options).forEach(([key, opts]) => {
                const existing = Array.isArray(masterFilterList[key]) ? masterFilterList[key] : [];
                const byId = new Map(existing.map(o => [String(o.id), o]));
                (opts || []).forEach(o => {
                    if (!byId.has(String(o.id))) byId.set(String(o.id), o);
                });
                masterFilterList[key] = [...byId.values()];
            });
            return {
                ...state,
                filterFields: newFields.length ? [...state.filterFields, ...enrichFilterFields(newFields)] : state.filterFields,
                masterFilterList
            };
        }
        case actionType.GET_QUERY_REQUEST:
            return {
                ...state,
                getQueryData: { ...action.response, isQueryLoading: true }
            };
        case actionType.GET_QUERY_SUCCESS:
            return {
                ...state,
                getQueryData: { success: true, ...action.response, isQueryLoading: false }
            };
        case actionType.GET_QUERY_FAILURE:
            return {
                ...state,
                getQueryData: { success: false, ...action.response, isQueryLoading: false }
            };
        case actionType.DELETE_QUERY_REQUEST:
            return {
                ...state
            };
        case actionType.DELETE_QUERY_SUCCESS:
            return {
                ...state,
                deleteQueryResponse: { success: true, ...action.response }
            };
        case actionType.DELETE_QUERY_FAILURE:
            return {
                ...state,
                deleteQueryResponse: { success: false, ...action.error }
            };
        case actionType.SAVE_FILTER_REQUEST:
            return {
                ...state
            };
        case actionType.SAVE_FILTER_SUCCESS:
            return {
                ...state,
                saveQueryResponse: { success: true, ...action.response }
            };
        case actionType.SAVE_FILTER_FAILURE:
            return {
                ...state,
                saveQueryResponse: { success: false, ...action.error }
            };
        case actionType.UPDATE_FILTER_REQUEST:
            return {
                ...state
            };
        case actionType.UPDATE_FILTER_SUCCESS:
            return {
                ...state,
                updateQueryResponse: { success: true, updateLoading: false, ...action.response }
            };
        case actionType.UPDATE_FILTER_FAILURE:
            return {
                ...state,
                updateQueryResponse: { success: false, updateLoading: false, ...action.error }
            };
        case actionType.UPDATE_FILTER_NAME:
            return {
                ...state,
                updateFilterName: { ...action.response }
            };
        case actionType.GET_USERS_BY_CLIENT_QUERY_REQUEST:
            return {
                ...state
            };
        case actionType.GET_USERS_BY_CLIENT_QUERY_SUCCESS: {
            return {
                ...state,
                getUserByClientQueryData: { success: true, ...action.response }
            };
        }
        case actionType.GET_USERS_BY_CLIENT_QUERY_FAILURE:
            return {
                ...state,
                getUserByClientQueryData: { success: false, ...action.error }
            };
        case actionType.CLEAR_USER_BY_CLIENT_QUERY_DATA:
            return {
                ...state,
                getUserByClientQueryData: {}
            };
        case actionType.GET_QUERY_FILTER_CREATED_USERS_REQUEST:
            return {
                ...state,
                getQueryFilterCreatedUsersData: {
                    ...state.getQueryFilterCreatedUsersData,
                    isLoading: true
                }
            };
        case actionType.GET_QUERY_FILTER_CREATED_USERS_SUCCESS:
            return {
                ...state,
                getQueryFilterCreatedUsersData: { success: true, isLoading: false, ...action.response }
            };
        case actionType.GET_QUERY_FILTER_CREATED_USERS_FAILURE:
            return {
                ...state,
                getQueryFilterCreatedUsersData: { success: false, isLoading: false, ...action.error }
            };
        case actionType.CLEAR_QUERY_FILTER_CREATED_USERS:
            return {
                ...state,
                getQueryFilterCreatedUsersData: {}
            };
        case actionType.ADD_QUERY_TO_FAVORITES_REQUEST:
            return {
                ...state
            };
        case actionType.ADD_QUERY_TO_FAVORITES_SUCCESS:
            return {
                ...state,
                addFavouriteQueryData: { success: true, ...action.response }
            };
        case actionType.ADD_QUERY_TO_FAVORITES_FAILURE:
            return {
                ...state,
                addFavouriteQueryData: { success: false, ...action.error }
            };
        case actionType.ASSIGN_FAVORITE_QUERY_TO_USERS_REQUEST:
            return {
                ...state
            };
        case actionType.ASSIGN_FAVORITE_QUERY_TO_USERS_SUCCESS:
            return {
                ...state,
                assignFavouriteQueryData: { success: true, ...action.response }
            };
        case actionType.ASSIGN_FAVORITE_QUERY_TO_USERS_FAILURE:
            return {
                ...state,
                assignFavouriteQueryData: { success: false, ...action.error }
            };
        case actionType.GET_QUICK_LINKS_REQUEST:
            return {
                ...state,
                getQuickLinksResponse: { loading: true }
            };
        case actionType.GET_QUICK_LINKS_SUCCESS:
            return {
                ...state,
                getQuickLinksResponse: { loading: false, success: true, ...action.response }
            };
        case actionType.GET_QUICK_LINKS_FAILURE:
            return {
                ...state,
                getQuickLinksResponse: { loading: false, success: false, ...action.error }
            };
        case actionType.ADD_TO_QUICK_LINKS_REQUEST:
            return {
                ...state,
                addToQuickLinks: { loading: true }
            };
        case actionType.ADD_TO_QUICK_LINKS_SUCCESS:
            return {
                ...state,
                addToQuickLinks: { loading: false, success: true, ...action.response }
            };
        case actionType.ADD_TO_QUICK_LINKS_FAILURE:
            return {
                ...state,
                addToQuickLinks: { loading: false, success: false, ...action.error }
            };
        case actionType.DELETE_QUICK_LINKS_REQUEST:
            return {
                ...state,
                deleteQuickLinks: { loading: true }
            };
        case actionType.DELETE_QUICK_LINKS_SUCCESS:
            return {
                ...state,
                deleteQuickLinks: { loading: false, success: true, ...action.response }
            };
        case actionType.DELETE_QUICK_LINKS_FAILURE:
            return {
                ...state,
                deleteQuickLinks: { loading: false, success: false, ...action.error }
            };
        case "SET_INITIAL_FILTERS_APPLIED":
            return { ...state, hasAppliedInitialFilters: true };
        case actionType.GET_DASHBOARD_MAP_LEASE_ASSET_COUNT_REQUEST:
            return {
                ...state
            };
        case actionType.GET_DASHBOARD_MAP_LEASE_ASSET_COUNT_SUCCESS:
            return {
                ...state,
                getDashboardLeaseAssetsCountResponse: { success: true, ...action.response }
            };
        case actionType.GET_DASHBOARD_MAP_LEASE_ASSET_COUNT_FAILURE:
            return {
                ...state,
                getDashboardLeaseAssetsCountResponse: { success: false, ...action.error }
            };
        case actionType.GET_CHART_DYNAMIC_FIELDS_REQUEST:
            return {
                ...state
            };
        case actionType.GET_CHART_DYNAMIC_FIELDS_SUCCESS:
            return {
                ...state,
                chartDynamicFields: { success: true, data: action.response }
            };
        case actionType.GET_CHART_DYNAMIC_FIELDS_FAILURE:
            return {
                ...state,
                chartDynamicFields: { success: false, ...action.error }
            };
        default:
            return state;
    }
};
